import script from "./RetornoDiferencas.vue?vue&type=script&setup=true&lang=ts"
export * from "./RetornoDiferencas.vue?vue&type=script&setup=true&lang=ts"

import "./RetornoDiferencas.vue?vue&type=style&index=0&id=a07611d8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a07611d8"]])

export default __exports__